import * as React from 'react';
import { Text } from '@chakra-ui/react';

export const SubmitErrorComponent = props => {
   return <Text className="formManagerStatus">{props.error}</Text>;
};
